<template>
  <g clip-path="url(#briefcase)">
    <path
      d="M14.6667 3.33353H11.3333V2.66684C11.3333 1.9315 10.7354 1.3335 10 1.3335H6C5.26466 1.3335 4.66666 1.93147 4.66666 2.66684V3.3335H1.33334C0.597969 3.33353 0 3.9315 0 4.66685V6.66685C0 7.40223 0.597969 8.0002 1.33334 8.0002H6.66669V7.66685C6.66669 7.4826 6.81578 7.33351 7.00003 7.33351H9.00003C9.18428 7.33351 9.33337 7.4826 9.33337 7.66685V8.0002H14.6667C15.402 8.0002 16 7.40223 16 6.66685V4.66685C16 3.9315 15.402 3.33353 14.6667 3.33353ZM10 3.33353H6V2.66684H10V3.33353Z"
      fill="#C2C6CD"
    />
    <path
      d="M15.8151 8.35991C15.7015 8.3036 15.5658 8.31663 15.4655 8.39279C15.2285 8.57216 14.9524 8.66688 14.6666 8.66688H9.33334V9.66688C9.33334 9.85113 9.18425 10.0002 9 10.0002H7C6.81575 10.0002 6.66666 9.85113 6.66666 9.66688V8.66688H1.33334C1.04753 8.66688 0.7715 8.57216 0.5345 8.39279C0.433906 8.31597 0.2985 8.30294 0.184875 8.35991C0.071625 8.41625 0 8.53179 0 8.65844V13.3336C0 14.0689 0.597969 14.6669 1.33334 14.6669H14.6667C15.402 14.6669 16 14.069 16 13.3336V8.65844C16 8.53179 15.9284 8.41625 15.8151 8.35991Z"
      fill="#C2C6CD"
    />
  </g>
  <defs>
    <clipPath id="briefcase">
      <rect width="16" height="16" fill="white" />
    </clipPath>
  </defs>
</template>
